import React, { Component as C } from "react"

import classnames from "classnames"
import T from "prop-types"

import styles from "../inputs.less"
import * as numberInputUtils from "../number-input-controls.es6"

export default class extends C {
  static propTypes = {
    className: T.string,
    dataQa: T.string,
    value: T.string,
    disabled: T.bool,
    notValid: T.bool,
    tabIndex: T.number,
    autoFocus: T.bool,
    type: T.oneOf(["double", "int"]),
    forbidNegative: T.bool,
    onChange: T.func,
    onBlur: T.func,
    isNotValid: T.bool,
    maxLength: T.number,
    digits: T.number,
  }

  static defaultProps = {
    type: "int",
    maxLength: 10,
    digits: 2,
  }

  handleKeyPress(e) {
    const isKeyAllowed = numberInputUtils.checkAllowedKey({
      type: this.props.type,
      which: e.which,
      oldValue: this.props.value,
      forbidNegative: this.props.forbidNegative,
    })

    if (!isKeyAllowed) {
      e.preventDefault()
    }
  }

  handleChange(e) {
    const { value, digits, maxLength, forbidNegative, type, onChange } = this.props

    if (!onChange) return

    const viewValue = numberInputUtils.normalizeChangedValue({
      type,
      newValue: e.target.value,
      forbidNegative,
      maxLength,
    })

    if (viewValue == null) return

    const oldValue = numberInputUtils.parseValue(type, value, digits)
    const newValue = numberInputUtils.parseValue(type, viewValue, digits)

    oldValue !== newValue && onChange(e, !isNaN(newValue) ? newValue : 0)
  }

  get value() {
    const { type, value, digits } = this.props

    return numberInputUtils.parseValue(type, value, digits)
  }

  render() {
    const inputClass = classnames(styles.input, this.props.className, {
      disabled: this.props.disabled,
      [styles.notValid]: this.props.notValid,
    })

    return (
      <input
        type="text"
        data-qa={this.props.dataQa}
        value={this.value}
        placeholder={this.props.placeholder}
        disabled={this.props.disabled}
        className={inputClass}
        onChange={this.handleChange.bind(this)}
        onKeyPress={this.handleKeyPress.bind(this)}
        tabIndex={this.props.tabIndex}
        autoFocus={this.props.autoFocus}
        onBlur={(event) =>
          setTimeout(() => this.props.onBlur(event), 250)}
        maxLength={this.props.maxLength}
      />
    )
  }
}
